export default __webpack_public_path__ + "static/media/element_spec_41.b6dcec4a.jpg";